import { Constants } from '@pwc/pwc-deals-web-common';
import { get } from 'lodash';
import { TABLEAU_LIBRARY_ITEM_TYPES } from 'common/components/SectionArea/libraryItemUtils.ts';
import { POWER_PIVOT_LIBRARY_ITEM_TYPES } from 'features/analyses/common/LibraryItemCard/PowerPivot/constants/PowerPivotTypes.ts';

const TABLEAU_CONSTANTS = {
  TABLEAU_REPORT: {
    displayName: 'Tableau Report',
    value: TABLEAU_LIBRARY_ITEM_TYPES.TableauReport,
  },
  TABLEAU_PAGE: {
    displayName: 'Tableau Tab',
    value: TABLEAU_LIBRARY_ITEM_TYPES.TableauReportPage,
  },
};

export const topicPanelType = {
  Undefined: 0,
  RichText: 1,
  Hypothesis: 2,
  ExcelChart: 3,
  ExcelNamedRange: 4,
  ExcelCellRange: 5,
  PowerBiReport: 6,
  Powerpoint: 7,
  PowerBiReportPage: 8,
  TableauReport: 9,
  TableauReportPage: 10,
  dynamicExcelCellRange: 13,
};

export const mapTopicPanels = ({
  topicLayoutTypeValue,
  contentTypeArray,
  richTextArray,
  hypothesisArray,
  excelChartIdArray,
  panelNumbersArray,
}) => {
  let numberOfPanels;

  switch (topicLayoutTypeValue) {
    case 18:
      numberOfPanels = 3;
      break;
    case 15:
      numberOfPanels = 2;
      break;
    case 14:
      numberOfPanels = 2;
      break;
    case 11:
      numberOfPanels = 2;
      break;
    case 8:
      numberOfPanels = 3;
      break;
    case 3:
      numberOfPanels = 3;
      break;
    case 2:
      numberOfPanels = 2;
      break;
    default:
      numberOfPanels = 1;
  }
  const placeholderArray = Array(numberOfPanels).fill(null);
  return placeholderArray
    .map((_, i) => {
      let panel = {
        panelNumber: panelNumbersArray?.[i] ?? i + 1,
      };
      switch (contentTypeArray[i]) {
        case Constants.TOPIC_PANEL_TYPES.RICH_TEXT.asString:
        case Constants.TOPIC_PANEL_TYPES.RICH_TEXT.value:
        case topicPanelType.RichText:
          panel.richText = richTextArray[i].content;
          panel.type = Constants.TOPIC_PANEL_TYPES.RICH_TEXT.value;
          panel.childLibraryItems = richTextArray[i].childLibraryItems;
          panel.libraryItemId = richTextArray[i].libraryItemId;
          break;
        case Constants.TOPIC_PANEL_TYPES.KEY_FOCUS_AREA.asString:
        case Constants.TOPIC_PANEL_TYPES.KEY_FOCUS_AREA.value:
          panel.hypothesisThreadId = get(
            hypothesisArray,
            [i, 'contentThreadId'],
            null
          );
          panel.type = Constants.TOPIC_PANEL_TYPES.KEY_FOCUS_AREA.value;
          break;
        case Constants.LIBRARY_ITEM_TYPES.EXCEL_CHART.value:
        case topicPanelType.ExcelChart:
          panel.libraryItemId = excelChartIdArray[i];
          panel.type = topicPanelType.ExcelChart;
          break;
        case Constants.LIBRARY_ITEM_TYPES.EXCEL_CELL_RANGE.value:
        case topicPanelType.ExcelCellRange:
          panel.libraryItemId = excelChartIdArray[i];
          panel.type = topicPanelType.ExcelCellRange;
          break;
        case Constants.LIBRARY_ITEM_TYPES.EXCEL_NAMED_RANGE.value:
        case topicPanelType.ExcelNamedRange:
          panel.libraryItemId = excelChartIdArray[i];
          panel.type = topicPanelType.ExcelNamedRange;
          break;
        case Constants.LIBRARY_ITEM_TYPES.POWER_POINT_GROUP.value:
        case topicPanelType.Powerpoint:
          panel.libraryItemId = excelChartIdArray[i];
          panel.type = topicPanelType.Powerpoint;
          break;
        case Constants.LIBRARY_ITEM_TYPES.POWER_BI_REPORT.value:
        case topicPanelType.PowerBiReport:
          panel.libraryItemId = excelChartIdArray[i];
          panel.type = topicPanelType.PowerBiReport;
          break;
        case Constants.LIBRARY_ITEM_TYPES.POWER_BI_REPORT_PAGE.value:
        case topicPanelType.PowerBiReportPage:
          panel.libraryItemId = excelChartIdArray[i];
          panel.type = topicPanelType.PowerBiReportPage;
          break;
        case TABLEAU_CONSTANTS.TABLEAU_REPORT.value:
        case topicPanelType.TableauReport:
          panel.libraryItemId = excelChartIdArray[i];
          panel.type = topicPanelType.TableauReport;
          break;
        case TABLEAU_CONSTANTS.TABLEAU_PAGE.value:
        case topicPanelType.TableauReportPage:
          panel.libraryItemId = excelChartIdArray[i];
          panel.type = topicPanelType.TableauReportPage;
          break;
        case topicPanelType.dynamicExcelCellRange:
        case POWER_PIVOT_LIBRARY_ITEM_TYPES.DynamicExcelCellRange:
        case POWER_PIVOT_LIBRARY_ITEM_TYPES.DynamicExcelNamedRange:
        case POWER_PIVOT_LIBRARY_ITEM_TYPES.DynamicExcelChart:
          panel.libraryItemId = excelChartIdArray[i];
          panel.type = topicPanelType.dynamicExcelCellRange;
          break;
        default:
          panel = null;
      }
      return panel;
    })
    .filter((item) => item);
};

const mapTopicLinks = (hypothesisArray, contentTypeArray) =>
  hypothesisArray
    .filter(
      (h, i) =>
        h &&
        contentTypeArray[i] ===
          Constants.TOPIC_PANEL_TYPES.KEY_FOCUS_AREA.asString
    )
    .map((h) => h.contentId);

export const mapTopic = ({
  topicLayoutTypeValue,
  richTextArray,
  hypothesisArray = [],
  contentTypeArray,
  excelChartIdArray,
  topicTitle,
  panelNumbersArray,
}) => {
  const topicToSaveDto = {
    title: topicTitle,
    layoutType: topicLayoutTypeValue,
  };

  topicToSaveDto.panels = mapTopicPanels({
    contentTypeArray,
    richTextArray,
    hypothesisArray,
    excelChartIdArray,
    topicLayoutTypeValue,
    panelNumbersArray,
  });

  topicToSaveDto.links = mapTopicLinks(hypothesisArray, contentTypeArray);

  return topicToSaveDto;
};
